export default __webpack_public_path__ + "static/media/iglesia.aab1c038.png";